import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { CoordinatesModel } from '../types/protocols';

interface MiniMapProps {
    coordinates: CoordinatesModel;
    buildingName?: string;
    height?: number;
}

/**
 * Compact map component for displaying a single building location in modals.
 * Non-interactive by default to avoid scroll conflicts in modals.
 */
const MiniMap: React.FC<MiniMapProps> = ({
    coordinates,
    buildingName,
    height = 200
}) => {
    const position: [number, number] = [coordinates.latitude, coordinates.longitude];

    return (
        <div
            style={{
                height,
                borderRadius: 8,
                overflow: 'hidden',
                border: '1px solid #dee2e6'
            }}
        >
            <MapContainer
                center={position}
                zoom={15}
                scrollWheelZoom={true}
                dragging={true}
                zoomControl={true}
                doubleClickZoom={true}
                touchZoom={true}
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />
                <Marker position={position} />
            </MapContainer>
        </div>
    );
};

export default MiniMap;
